export namespace MimeTypeNamespace {

    /**
     * Mime типы разных файлов, используемых в проекте
     */
    export enum MimeEnums {
        pdf = 'application/pdf',

        imagePNG = 'image/png',
        imageJPEG = 'image/jpeg',
        imageJPG = 'image/jpg',

        tiff = 'image/tiff',

        officeDOC = 'application/msword',
        officeDOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        officeRTF = 'application/rtf',
        officeXLS = 'application/vnd.ms-excel',
        officeXLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        officeODT = 'application/vnd.oasis.opendocument.text',
        officeODS = 'application/vnd.oasis.opendocument.spreadsheet',

        csv = 'text/csv',
    }

    /**
     * Возможные расширения разных типов файлов
     */
    export const extensionsByType: {[key: string]: string[]} = {
        [MimeEnums.pdf]: ['pdf'],
        [MimeEnums.imageJPG]: ['jpg'],
        [MimeEnums.imageJPEG]: ['jpeg'],
        [MimeEnums.imagePNG]: ['png'],
        [MimeEnums.tiff]: ['tiff', 'tif'],
        [MimeEnums.officeDOC]: ['doc'],
        [MimeEnums.officeDOCX]: ['docx'],
        [MimeEnums.officeODS]: ['ods'],
        [MimeEnums.officeODT]: ['odt'],
        [MimeEnums.officeRTF]: ['rtf'],
        [MimeEnums.officeXLS]: ['xls'],
        [MimeEnums.officeXLSX]: ['xlsx'],
        [MimeEnums.csv]: ['csv'],
    };

    /**
     * Получить типы изображений
     */
    export const getImageTypes = (): string[] => {
        return [
            MimeEnums.imageJPEG,
            MimeEnums.imageJPG,
            MimeEnums.imagePNG,
        ];
    };

    /**
     * Получить типы офисных файлов
     */
    export const getOfficeTypes = (): string[] => {
        return [
            MimeEnums.officeDOC,
            MimeEnums.officeDOCX,
            MimeEnums.officeRTF,
            MimeEnums.officeXLS,
            MimeEnums.officeXLSX,
            MimeEnums.officeODT,
            MimeEnums.officeODS,
        ];
    };

    /**
     * Является ли переданный Mime картинкой
     * @param mime
     */
    export const isImage = (mime: MimeEnums|string): boolean => {
        return getImageTypes().includes(mime);
    };

    /**
     * Может ли файл с указанным типом быть предпросмотрен в браузере
     * Предпросмотренным может быть только изображение или PDF
     * @param type
     */
    export const isFilePreviewableInBrowser = (type: MimeEnums): boolean => {
        return [...getImageTypes(), MimeEnums.pdf].includes(type);
    };

    /**
     * Получить ссылку на картинку с нужной SVG иконкой
     * @param type
     */
    export const getMimeImageUrl = (type?: MimeEnums): string => {
        return `/images/mime-icons/${extensionsByType[type] && extensionsByType[type][0] || 'noname'}.svg`;
    };
}
